import { createReducer } from 'typesafe-actions'
import { ReadUserWalletsRequestDto, ReadUserWalletsResponseDto } from '@sparling/financial-common'
import { omit } from 'lodash'
import { ActionTypes } from '../types'
import { LoadingStateEnum } from '../../types'
import { getUserWalletsFailure, getUserWalletsRequest, getUserWalletsSuccess } from '../actions'

const initialMetaState = {
  currentPage: 0,
  itemCount: 0,
  itemsPerPage: 0,
  totalItems: 0,
  totalPages: 0,
}

export type UserWalletsState = {
  loading: LoadingStateEnum
  data: ReadUserWalletsResponseDto
  filters: Partial<ReadUserWalletsRequestDto>
  error: Error | null
}

export const initialState = {
  loading: LoadingStateEnum.IDLE,
  data: {
    success: true,
    data: {
      items: [],
      meta: initialMetaState,
    },
  },
  filters: {},
  error: null,
  assignedUserWallets: {
    idSf: null,
    loading: LoadingStateEnum.IDLE,
    data: {
      items: [],
      meta: initialMetaState,
    },
    assignedIds: [],
    error: null,
  },
}

export const userWallets = createReducer<UserWalletsState, ActionTypes>(initialState)
  .handleAction(getUserWalletsRequest, (state, { payload }) => ({
    ...state,
    filters: {
      ...state.filters,
      ...payload,
      page: Object.keys(omit(payload, 'page')).length > 0 ? 1 : payload.page,
    },
    loading: LoadingStateEnum.LOADING,
  }))
  .handleAction(getUserWalletsSuccess, (state, { payload }) => ({
    ...state,
    loading: LoadingStateEnum.SUCCESS,
    data: payload,
  }))
  .handleAction(getUserWalletsFailure, (state, { payload }) => ({
    ...state,
    loading: LoadingStateEnum.ERROR,
    error: payload,
  }))
